(function() {
  var CUSTOM_VARIANT_ID = '42636217942064';
  var MIN_DONATION = 25;

  var productForm = document.querySelector('.product-single__form');
  if (!productForm) return;

  var variantSelect = productForm.querySelector('[data-product-select]');
  if (!variantSelect) return;

  var hasCustomVariant = false;
  for (var i = 0; i < variantSelect.options.length; i++) {
    if (variantSelect.options[i].value === CUSTOM_VARIANT_ID) {
      hasCustomVariant = true;
      break;
    }
  }
  if (!hasCustomVariant) return;

  // Create or find quantity input - inject hidden one if not present
  var qtyInput = productForm.querySelector('[name="quantity"]');
  if (!qtyInput) {
    qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';
    productForm.appendChild(qtyInput);
  }

  // Create the donation amount input UI
  var wrapper = document.createElement('div');
  wrapper.id = 'custom-donation-wrap';
  wrapper.style.display = 'none';
  wrapper.innerHTML =
    '<div style="margin: 16px 0;">' +
      '<label for="custom-donation-amount" style="display:block; font-size:14px; font-weight:600; margin-bottom:8px;">Enter Donation Amount (min $' + MIN_DONATION + ')</label>' +
      '<div style="display:flex; align-items:center; gap:8px;">' +
        '<span style="font-size:18px; font-weight:600;">$</span>' +
        '<input type="number" id="custom-donation-amount" min="' + MIN_DONATION + '" step="1" value="' + MIN_DONATION + '" ' +
          'style="width:120px; padding:10px 12px; border:1px solid #ccc; border-radius:4px; font-size:16px;" />' +
      '</div>' +
      '<p id="custom-donation-error" style="color:#c00; font-size:13px; margin-top:6px; display:none;">Minimum donation is $' + MIN_DONATION + '</p>' +
    '</div>';

  var qtyWrap = document.querySelector('.product__quantity');
  var formArea = productForm.querySelector('[data-add-to-cart]');
  if (formArea) {
    formArea.parentNode.insertBefore(wrapper, formArea);
  }

  var donationInput = wrapper.querySelector('#custom-donation-amount');
  var errorMsg = wrapper.querySelector('#custom-donation-error');

  function isCustomSelected() {
    return variantSelect.value === CUSTOM_VARIANT_ID;
  }

  function syncQty() {
    if (!isCustomSelected()) return;
    var val = parseInt(donationInput.value, 10);
    if (isNaN(val) || val < MIN_DONATION) {
      errorMsg.style.display = 'block';
      qtyInput.value = MIN_DONATION;
    } else {
      errorMsg.style.display = 'none';
      qtyInput.value = val;
    }
  }

  function updateVisibility() {
    if (isCustomSelected()) {
      wrapper.style.display = 'block';
      if (qtyWrap) qtyWrap.style.display = 'none';
      syncQty();
      var val = parseInt(donationInput.value, 10) || MIN_DONATION;
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) priceEl.innerHTML = '$' + val + '.00';
    } else {
      wrapper.style.display = 'none';
      if (qtyWrap) qtyWrap.style.display = '';
      qtyInput.value = 1;
    }
  }

  donationInput.addEventListener('input', function() {
    syncQty();
    var val = parseInt(donationInput.value, 10) || 0;
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && isCustomSelected()) {
      priceEl.innerHTML = '$' + val + '.00';
    }
  });
  donationInput.addEventListener('change', syncQty);

  // Watch for variant select changes
  variantSelect.addEventListener('change', updateVisibility);

  // Impulse theme updates the hidden select via JS - watch for mutations
  var observer = new MutationObserver(function() {
    updateVisibility();
  });
  observer.observe(variantSelect, { attributes: true, childList: true, subtree: true });

  // Listen for variant button clicks
  var variantButtons = document.querySelectorAll('[data-variant-input]');
  variantButtons.forEach(function(btn) {
    btn.addEventListener('change', function() {
      setTimeout(updateVisibility, 50);
    });
  });

  // Intercept AJAX add-to-cart as well (Impulse uses fetch/XHR)
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    if (isCustomSelected() && typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && opts.body) {
      var val = parseInt(donationInput.value, 10);
      if (isNaN(val) || val < MIN_DONATION) val = MIN_DONATION;

      // Handle FormData body
      if (opts.body instanceof FormData) {
        opts.body.set('quantity', val.toString());
      }
      // Handle URL-encoded string body
      if (typeof opts.body === 'string' && opts.body.indexOf('quantity=') !== -1) {
        opts.body = opts.body.replace(/quantity=\d+/, 'quantity=' + val);
      }
      // Handle JSON body
      if (typeof opts.body === 'string') {
        try {
          var json = JSON.parse(opts.body);
          if (json.quantity !== undefined) {
            json.quantity = val;
            opts.body = JSON.stringify(json);
          }
        } catch(e) {}
      }
    }
    return origFetch.apply(this, arguments);
  };

  // Also intercept XMLHttpRequest for older code paths
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (isCustomSelected() && this._url && this._url.indexOf('/cart/add') !== -1 && body) {
      var val = parseInt(donationInput.value, 10);
      if (isNaN(val) || val < MIN_DONATION) val = MIN_DONATION;
      if (typeof body === 'string' && body.indexOf('quantity') !== -1) {
        try {
          var json = JSON.parse(body);
          json.quantity = val;
          body = JSON.stringify(json);
        } catch(e) {
          body = body.replace(/quantity=\d+/, 'quantity=' + val);
        }
      }
    }
    return origXHRSend.call(this, body);
  };
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origXHROpen.apply(this, arguments);
  };

  // Also intercept form submit
  productForm.addEventListener('submit', function(e) {
    if (isCustomSelected()) {
      var val = parseInt(donationInput.value, 10);
      if (isNaN(val) || val < MIN_DONATION) {
        e.preventDefault();
        e.stopPropagation();
        errorMsg.style.display = 'block';
        donationInput.focus();
        return false;
      }
      qtyInput.value = val;
    }
  });

  // Initial state
  updateVisibility();
})();
